<template>
  <div class="profile-page">
    <div>
      <div class="select-plan">
        <div class="select-plan-text">Select your plan</div>
      </div>
      <div class="vip-desc-box">
        <div class="vip-desc">
          Subscribe now to unlock unlimited creativity! Experience our face swap
          technology that adds fun and surprises to your videos, ensuring you never miss a
          memorable moment!
        </div>
      </div>
      <div class="vip-desc-box"><div class="fengexian"></div></div>
      <!-- <div class="vip-plan-box">
        <div class="vip-plan-box-left">
          <div class="vip-price">
            ${{ payInfo.price }} /{{ payTypeYear ? "Year" : "Month" }}
          </div>
          <div v-if="payTypeYear" @click="PayTypeClick">
            <img style="cursor: pointer;" src="@/assets/img/paymonthly.png" alt="" />
          </div>
          <div v-else @click="PayTypeClick">
            <img style="cursor: pointer;" src="@/assets/img/payyearly.png" alt="" />
          </div>
        </div>
      </div>
      <div class="vip-plan-box">
        <div class="vip-plan-box-right">
          <div class="vip-save">Save {{ payInfo.discount }}</div>
          <div class="vip-old-price">${{ payInfo.originalPrice }}</div>
        </div>
      </div> -->
      <div v-for="goods in goodsList" :key="goods.id"
        :class="'recharge-main-item ' + (payInfo.id == goods.id ? 'active' : '')"
        @click="goodsClick(goods)">
        <div class="topback" v-if="goods.discount">{{ goods.discount }} OFF</div>
        <div class="pay-item">
          <div :class="'item-top ' + (payInfo.id == goods.id ? 'active' : '')"></div>
          <div class="item-center">
            <div class="item-center-left">{{ goods.name }}</div>
            <div class="item-bottom">${{ goods.price }}</div>
          </div>
        </div>

      </div>
      <div class="vip-plan-footer">
        <div>
          <div class="vip-plan-footer-item">
            <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
            <div class="vip-plan-footer-item-desc">Priority processing queue</div>
          </div>
          <div class="vip-plan-footer-item">
            <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
            <div class="vip-plan-footer-item-desc">Unlock all Pro templates</div>
          </div>
          <div class="vip-plan-footer-item">
            <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
            <div class="vip-plan-footer-item-desc">No watermark</div>
          </div>
          <div class="vip-plan-footer-item">
            <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
            <div class="vip-plan-footer-item-desc">No ads.</div>
          </div>
          <div class="vip-plan-footer-item">
            <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
            <div class="vip-plan-footer-item-desc">Pro speed.Multi-task</div>
          </div>
          <div class="vip-plan-footer-item">
            <div><img class="vip-gou-img" src="@/assets/img/gougou.png" alt="" /></div>
            <div class="vip-plan-footer-item-desc">Cancel anytime</div>
          </div>
        </div>
      </div>
      <div v-if="!userInfo.isVip" class="vip-plan-footer-btn">
        <div id="paypal-button-container"></div>
        <!-- <img src="@/assets/img/continue-btn.png" class="vip-plan-footer-btn-img" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";
import { getGoodsList, queryPlanList, createOrder,payOrderNotify } from "@/request/modules/pay.js";
import { GetTypeList  } from "@/request/modules/home.js";
export default {
  name: "vipRecharge",
  props: {
    header: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      payTypeYear: true,
      custom_id: "",
      isFangDouDong: true,
      goodsListTemp: [],
      goodsList: [],
      payInfo: {},
      orderInfo: {},
      userInfo:null,
      client_id:""
    };
  },
  async mounted() {
    this.userInfo =JSON.parse(localStorage.getItem("userInfo")) ;
    console.log("userInfo",this.userInfo)
    await this.getBaseUrl();
    await this.onloadProject();
    await this.createPayBtn();
  },
  methods: {
    async getBaseUrl(){
      var res = await GetTypeList({
        typeId: 7011,
        p: 1,
        s: 100,
        o: 1,
        c: "sort",
      });
      this.baseUrl = res.rows;
      this.baseUrl.map(item=>{
        if (item.label == "paypal_client_id") {
          console.log("item",item.value)
          this.client_id = item.value
        }
      })
    },
    async createPayBtn() {
      if (this.userInfo.isVip) {
        return;
      }
      let paypal;
      let that = this;
      try {
        paypal = await loadScript({
          clientId:this.client_id,
          vault: true,
          intent: "subscription",
        });
      } catch (error) {
        console.error("failed to load the PayPal JS SDK script", error);
      }

      if (paypal) {
        try {
          await paypal
            .Buttons({
              async createSubscription(data, actions) {
                console.log("创建订单", that);
                var res = await createOrder({
                    channel: 'paypal',
                    basePlanId: that.payInfo.planCode,
                    goodsCode: that.goodsListTemp[0].goodsCode,
                });
                that.orderInfo = res;
                console.log('传递的paypalPlanCode',that.payInfo.paypalPlanCode)
                if (that.orderInfo.orderNo) {
                  return actions.subscription.create({
                    plan_id: that.payInfo.paypalPlanCode,
                    custom_id: that.orderInfo.orderNo,
                  });
                }
              },
              async onApprove(data) {
                var res = await payOrderNotify({
                    notifyData:JSON.stringify(data),
                    orderNo: that.orderInfo.orderNo
                });
                if (that.orderInfo && that.payInfo) {
                  that.logEvent('fw_vip_success',{fw_module_name:'vipRecharge',fw_page:'vipRecharge',fw_sub_goods:that.orderInfo.orderNo,fw_sub_plan:that.payInfo.paypalPlanCode}) 
                }
                that.$emit("paySuccess");
                
                //   alert(`Transaction completed by ${details.payer.name.given_name}`);
              },
              onError(error) {
                // For example, redirect to a specific error page
                that.logEvent('fw_vip_fail',{fw_module_name:'vipRecharge',fw_page:'vipRecharge',fw_sub_goods:that.orderInfo.orderNo,fw_sub_plan:that.payInfo.paypalPlanCode})
                console.log("error", error);
              },
              onCancel(data) {
                // Show a cancel page, or return to cart
                that.logEvent('fw_vip_cancel',{fw_module_name:'vipRecharge',fw_page:'vipRecharge',fw_sub_goods:that.orderInfo.orderNo,fw_sub_plan:that.payInfo.paypalPlanCode})
                console.log("data", data);
              },
            })
            .render("#paypal-button-container");
        } catch (error) {
          console.error("failed to render the PayPal Buttons", error);
        }
      }
    },
    async onloadProject() {
      var res = await getGoodsList({
        p: 1,
        s: 20,
        type: 1,
      });
      this.goodsListTemp = res.rows;
      if (this.goodsListTemp.length > 0) {
        var res2 = await queryPlanList(this.goodsListTemp[0].id);
        this.goodsList = res2;
        console.log("这个是列表", res2);
        this.payInfo = this.goodsList.filter(function (item) {
          return item.planCode == "vip-yearly";
        })[0];

        console.log("payInfo", this.payInfo);
      }
    },
    PayTypeClick() {
      this.payTypeYear = !this.payTypeYear;
      if (this.payTypeYear) {
        this.payInfo = this.goodsList.filter(function (item) {
          return item.planCode == "vip-yearly";
        })[0];
      } else {
        this.payInfo = this.goodsList.filter(function (item) {
          return item.planCode == "vip-monthly";
        })[0];
      }
    },
    handleGoFace(item) {
      console.log("item", item);
      this.$router.push({ path: `/face/templateView`, query: { type: item } });
    },
    goodsClick(item){
      this.payInfo = item;
    }
  },
  created() {},
};
</script>

<style lang="less" scoped>
.profile-page {
  color: #ffffff;
}
.fengexian {
  margin: 5px;
  height: 1px;
  background: linear-gradient(90deg, #00FFFF 3%, #8C1AF0 102%);
  width: 430px;
}
.vip-desc-box {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  .vip-desc {
    color: #1B1E1D;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    width: 419px;
  }
}
.select-plan {
  display: flex;
  justify-content: center;
  .select-plan-text {
    width: 430px;
    font-family: 思源黑体;
    font-size: 45px;
    background: linear-gradient(90deg, #00FFFF 4%, #8C1AF0 102%);
    -webkit-text-fill-color: transparent;
    background-clip: text;
    height: 55px;
  }
}
.vip-plan-box {
  display: flex;
  justify-content: center;
  .vip-plan-box-left {
    display: flex;
    justify-content: space-between;
    width: 430px;
    margin-top: 15px;
    align-items: center;
    .vip-price {
      font-family: PingFang SC;
      font-size: 21px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0em;
    }
  }
  .vip-plan-box-right {
    display: flex;
    width: 430px;
    .vip-save {
      font-family: PingFang SC;
      font-size: 12px;
      font-weight: 600;
      background: #0256ff;
      border-radius: 5px;
      width: 63px;
      height: 30px;
      line-height: 30px;
      padding: 0 2px;
    }
    .vip-old-price {
      color: #767676;
      font-family: PingFang SC;
      font-size: 21px;
      font-weight: 600;
      line-height: 30px;
      height: 30px;
      margin-left: 15px;
      text-decoration: line-through;
      text-decoration-color: #ff0000;
    }
  }
}
.vip-plan-footer {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  .vip-plan-footer-item {
    display: flex;
    align-items: center;
    width: 430px;
    margin-top: 5px;
    .vip-gou-img {
      width: 14px;
      height: 14px;
    }
    .vip-plan-footer-item-desc {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      margin-left: 10px;
      color: #111111;
    }
  }
}
.vip-plan-footer-btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .vip-plan-footer-btn-img {
    width: 343px;
    height: 50px;
    border-radius: 10px;
  }
}
.recharge-main-item {
		position: relative;
		width: 343px;
		height: 60px;
		margin: 10px auto;

		border: 2px solid transparent;
		border-radius: 12px;

		background-image: linear-gradient(0deg, #FFFFFF 0%, #FFFFFF 100%),
			linear-gradient(0deg, #272727 0%, #272727 100%);

		background-origin: border-box;
		background-clip: content-box, border-box;

	}

	.recharge-main-item.active {
		background-image: linear-gradient(0deg, #FFFFFF 100%, #FFFFFF 100%),
			linear-gradient(90deg, #00FFFF 4%, #8C1AF0 102%);
	}

	.pay-item {
		display: flex;
		align-items: center;
		height: 56px;
	}



	.item-top {

		margin-left: 20px;

		width: 18px;
		height: 18px;
		border-radius: 1000px;
		opacity: 1;

		box-sizing: border-box;
		border: 2px solid #262626;
	}

	.item-top.active {


		box-sizing: border-box;
		/* 2主色 */
		border: 5px solid transparent;

		background-image: linear-gradient(0deg, #111 0%, #111 100%),
			linear-gradient(90deg, #00FFFF 0%, #8C1AF0 102%);

		background-origin: border-box;
		background-clip: content-box, border-box;

	}


	.topback {
		position: absolute;
		width: 96px;
		height: 21px;
    border-radius: 0px 12px 0px 24px;
		right: 0;
		top: 0;

		font-size: 12px;
		font-weight: 600;
		line-height: normal;
		letter-spacing: 0em;
		color: #000000;
    background: linear-gradient(270deg, #1BBFEC 0%, #21D0C2 100%);
		background-repeat: no-repeat;
		background-size: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
    font-family: PingFang SC;
	}

	.item-center {
		margin-left: 18px;
		display: flex;
		justify-content: space-between;
		flex: 1;

		.item-center-left {
			font-size: 16px;
			color: #000000;
			flex: 1;
      font-family: PingFang SC;
		}

		.item-bottom {
			margin-right: 32px;
			font-size: 16px;
			color: #000000;
      font-family: PingFang SC;
		}
	}
</style>
